<script>
  let {
    entryId,
    notes = [],
    expandedNotesId = '',
    onToggle = () => {},
  } = $props();
</script>

<button
  type="button"
  class="notes-toggle"
  class:has-notes={notes.length > 0}
  disabled={notes.length === 0}
  aria-expanded={expandedNotesId === entryId}
  onclick={() => onToggle(entryId)}
>
  {notes.length}
</button>
